<div class="mb-3">
  @if (label()) {
    <div class="d-flex justify-content-between align-items-center mb-00">
      <label [for]="inputId()" class="form-label mb-0">
        {{ label() }}
      </label>
      @if (displayText()) {
        <strong>{{ displayText() }}</strong>
      }
    </div>
  }

  <!-- A slider running through zero names its two directions on their own line, so the track can span the
       full width instead of sharing it with two words. -->
  @if (hasDirectionLabels()) {
    <div class="d-flex justify-content-between text-secondary">
      <span>{{ negativeLabel() }}</span>
      <span>{{ positiveLabel() }}</span>
    </div>
  }

  <div class="row align-items-center gx-0">
    @if (!hasDirectionLabels()) {
      <div class="col-auto text-secondary">
        <div class="extrema" aria-hidden="true">{{ min() }}</div>
      </div>
    }
    <div class="col">
      <input
        data-1p-ignore
        data-bwignore
        data-lpignore="true"
        data-form-type="other"
        type="range"
        [id]="inputId()"
        [min]="min()"
        [max]="max()"
        [step]="step()"
        [value]="value() ?? ''"
        (input)="onInput($event)"
        (change)="onValueChange($event)"
        (blur)="onBlur()"
        [disabled]="disabled()"
        class="form-range"
        [style.--value-start.%]="fillStartPercentage()"
        [style.--value-end.%]="fillEndPercentage()"
      />
    </div>
    @if (!hasDirectionLabels()) {
      <div class="col-auto text-end text-secondary">
        <div class="extrema" aria-hidden="true">{{ max() }}</div>
      </div>
    }
  </div>
</div>
